/**
 *
 * Asynchronously loads the component for ReportConsumablesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ReportConsumablesPage = lazyLoad(
  () => import('./index'),
  module => module.ReportConsumablesPage,
);
